import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      timeout(1800000), // 30 minutes timeout
      catchError(error => {
        if (error.name === 'TimeoutError') {
          // handle timeout error
          console.error('Request timed out');
        }
        return throwError(error);
      })
    );
  }
}
